module.exports = __webpack_public_path__ + "static/stripe_work-9abe0e17dbf5680b61836b8abda52031.png";